import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../_actions';
import React, { useState } from 'react';
import { userService } from '../_services';
import './DeleteUser.css';

class DeletePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userOptions: [],
            user: null,
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.fGetUsernames();

    }

    handleChange(event) {
        const id = event.target.value;
        const option = this.state.userOptions.find(o => o.id === id);

        this.setState({ user: option ?? null });
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({ submitted: true });
        const { user } = this.state;
        const { dispatch } = this.props;

        try {
            const ok = await dispatch(userActions.register4(user));
            this.setState({ user: null });

            setTimeout(() => {
                this.fGetUsernames();
            }, 3000);

        } catch (e) {
            console.log(e);
        }
    }

    async fGetUsernames() {
        userService.getAll().then(users => {
            const userOptions = users.userList.map(u => ({
                id: u.id,
                userName: u.userName
            }));

            this.setState(
                {
                    userOptions,
                    user: null
                });
        });
    }

    render() {
        const { deleting } = this.props;
        const { userOptions, user } = this.state;

        return (
            <form name="form" onSubmit={this.handleSubmit}>
                <div className='form-group'>
                    <div className="columns dropdown-wrapper">
                        <select id="arr" className="form-control custom-select" name="username" value={user?.id ?? ''} onChange={this.handleChange}>
                            <option>Select user</option>
                            {userOptions.map(o => (
                                <option key={o.id} value={o.id}>
                                    {o.userName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <button className="btn btn-primary" disabled={deleting || user === null }>Delete</button>
                    {deleting &&
                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <button className="btn btn-link ms-16" type="button" onClick={() => {
                        this.setState({
                            user: { id: "", userName: "" }
                        });
                    }}>Cancel</button>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => ({
    deleting: state?.users.deleting
});

export default connect(mapStateToProps)(DeletePage);
